import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

import { useHelpCenterProducts } from '../../../hooks/use-help-center-products';

interface LearnMoreIconProps {
  productType?: string;
  productSubType?: string;
}

export function LearnMoreIcon({ productType, productSubType }: LearnMoreIconProps) {
  const { formatMessage } = useIntl();
  const learnMoreLabel = formatMessage({ id: 'learnMore.learnMore' });
  const { getProduct, openLearnMore } = useHelpCenterProducts();

  const productInfo = getProduct(productType, productSubType);

  if (!productInfo) {
    return null;
  }

  function onClickLearnMore() {
    logAnalytics.trackEvent('Primary market static', 'Open tutorial');
    openLearnMore(productType, productSubType);
  }

  return (
    <button
      type="button"
      title={learnMoreLabel}
      aria-label={learnMoreLabel}
      className="btn btn-sm btn-icon btn-flat-secondary"
      onClick={onClickLearnMore}
    >
      <span className="icon">info_outline</span>
    </button>
  );
}
